import type { RequestInterface } from '~/common/types';
import type { Category } from '~/categories/types';

export class CategoriesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/categories';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetCategoryRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    id,
    params,
  }: {
    token: string;
    id: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/categories/${id}`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
export class CreateCategoryRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/categories';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, category }: { token: string; category: Category }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...category,
    };
  }
}

export class UpdateCategoryRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, category }: { token: string; category: Category }) {
    this.path = `/api/v1/categories/${category.id}`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...category,
    };
  }
}

export class DeleteCategoryRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, id }: { token: string; id: string }) {
    this.path = `/api/v1/categories/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
